export default __webpack_public_path__ + "static/media/nftArt1.29575fac.png";